Vue.config.productionTip = false

import 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

import 'element-ui/lib/theme-chalk/index.css'
import app from './App.vue'
import routes from './router.js'
import VueRouter from 'vue-router'
import store from './store/index.js'
import echarts from 'echarts'

var Browser_Agent=navigator.userAgent;
var str1 = window.location.href.split("/")[2];
var str2 = document.location.protocol;
if(str1 == 'localhost:8080' || str1 == '127.0.0.1:8080'){
  str2 = 'http:';
}
// import markerclusterer from './store/markerclusterer.js'
// import richmarker from './store/richmarker.js'
// window.onload = function() {
  //do something
  // document.write("<script src='./src/store/richmarker.js'><\/script>");
// }
import jq from './store/jquery-3.3.1.min.js'
import jq_print from './store/jQuery.print.js'

import ezuikit_hls from './store/ezuikit_hls.js'
import ezuikit_talk from './store/ezuikit-talk.js'
import layer from './store/layer.js'

// import md5 from './store/md5.js'
// import base64 from './store/jquery.base64.js'
// let client_key = $.md5(navigator.userAgent);
// $.ajax({
//     type:'POST',
//     url:'http://www.roadsmart.cn/api/login/verify',
//     data:{
//       username:'zns',
//       client_key:client_key,
//       password:'zns',
//       version:0,
//     },
//     success:function(data){
//       // document.cookie="username=John Doe;";
//       var data = JSON.parse(data);
//       if(data.status == '0000'){
//         // console.log(data)
//         data.data.client_key = client_key;
//         data.data.username = 'zns';
//         data.data.version = 0;
//         storage.setItem('UserInformation',JSON.stringify(data));

//         storage.setItem('rememberPassword','true');
//         storage.setItem('udfn','zns');
//         storage.setItem('udfp',$.base64.encode('zns'));
//         storage.setItem('loginState','false');
//         storage.setItem('projectId','false');
//         storage.setItem('companyId','false');
//       }
//     }
// });

let storage = window.localStorage;
let version = 0;
if(storage.getItem("UserInformation")){
    var UserInformation = JSON.parse(storage.getItem("UserInformation"));
    if(UserInformation.data){
        if(UserInformation.data.version){
            version = UserInformation.data.version;
        }
    }
}
console.log(version)
if(version == 0){
    Vue.use(ElementUI)
}else{
    // 浏览器为ie的情况
    if(Browser_Agent.indexOf("MSIE")!=-1){
        var a=navigator.browserLanguage;
        // console.log(a)
        if(a !="zh-cn"){
            document.write("<script src='"+str2+"//maps.googleapis.com/maps/api/js?key=AIzaSyD_FHQc9qTI5SPvTBV0SQ-aPS2HJHm8H9U&language=en'><\/script>");
        }else{
            document.write("<script src='https://maps.googleapis.com/maps/api/js?key=AIzaSyD_FHQc9qTI5SPvTBV0SQ-aPS2HJHm8H9U&language=en'><\/script>");
        }
    }
    //浏览器非ie的情况
    else{
        var b=navigator.language;
        // console.log(b)
        if(b!="zh-CN"){
            document.write("<script src='"+str2+"//maps.googleapis.com/maps/api/js?key=AIzaSyD_FHQc9qTI5SPvTBV0SQ-aPS2HJHm8H9U&language=en'><\/script>");
        }else{
            document.write("<script src='https://maps.googleapis.com/maps/api/js?key=AIzaSyD_FHQc9qTI5SPvTBV0SQ-aPS2HJHm8H9U&language=en'><\/script>");
        }
    }
    document.write("<script src='./src/store/richmarker.js'><\/script>")
    Vue.use(ElementUI, { locale })
}

Vue.prototype.$echarts = echarts
Vue.use(VueRouter)
const router = new VueRouter({
    routes
});

import baseApi from './api/base.js'
import allUrl from './api/allUel.js'

var url = window.location.href.split("/")[2];
    // console.log(url,'---------')
var protocolStr = document.location.protocol;
if(protocolStr == "http:"){

}else if(protocolStr == "https:"){
    let subStr=new RegExp('http:');//创建正则表达式对象
    for(let i in allUrl){
        for(let key in allUrl[i]){
          allUrl[i][key]=allUrl[i][key].replace(subStr,protocolStr);
        }
    }
}
var street;
if(url == 'localhost:8080' || url == '127.0.0.1:8080'){
    // street = 'newtest.solar-iot.com'
    // street = 'www.solar_copy.com';
    street = 'www.roadsmart.cn';
    protocolStr = 'https:'
}else{
    street = url;
}
let subStr=new RegExp('newtest.solar-iot.com');//创建正则表达式对象
for(let i in allUrl){
    for(let key in allUrl[i]){
      allUrl[i][key]=allUrl[i][key].replace(subStr,street);
    }
}

let isTrue = true;
router.beforeEach((to, from, next) => {
    if(isTrue){
        isTrue = false;
        store.commit('routerLink',{
            linkTo:to.path
        })
        next();
    }else{
        if(to.path == '/home' || to.path == '/' || to.path == '/userManagement' || to.path == '/projectSummary'){
            store.commit('routerLink',{
                linkTo:to.path
            })
            next();
        }
        let arr= [{key:'2',val:'/GISMap'},{key:'3',val:'/projectManagement'},
                {key:'7',val:'/alarmMaintenance'},{key:'7',val:'/repairPersonnel'},{key:'7',val:'/maintenanceRecord'},{key:'7',val:'/streetLightInformation'},
                {key:'12',val:'/historicalData'},
                {key:'53',val:'/videoSurveillance'},{key:'53',val:'/monitoringDetails'},
                {key:'55',val:'/weatherMonitor'},
                {key:'15',val:'/operationLog'},
                {key:'60',val:'/grouping'},{key:'60',val:'/addGrouping'},
                {key:'6',val:'/strategy'},
                {key:'55',val:'/weatherMonitor'},{key:'55',val:'/monitorDetails'},{key:'55',val:'/monitoringContrast'},]
        console.log(to.path,store.getters.privilege)

        let data;
        if(storage.getItem("UserInformation") != 'false' && storage.getItem("UserInformation")){
            console.log(JSON.parse(storage.getItem("UserInformation")))
            data = JSON.parse(storage.getItem("UserInformation")).data;
            let isImplement = false;
            for(let d of arr){
                if(d.val==to.path){
                    for(let val of data.privilege){
                        if(d.key == val){
                            isImplement = true;
                        }
                    }
                }
            }
            // console.log(arr,to.path,'-----------------',data.privilege)
            if(data.role == '1' || to.path == '/' || to.path == '/home' || to.path == '/userManagement' || to.path == '/projectSummary'){
                isImplement = true;
            }
            if(isImplement){
                if(to.path == '/'){
                    var time = setInterval(function(){
                        if(document.getElementsByClassName('header')[0]){
                            document.getElementsByClassName('header')[0].className = 'header_centre box';
                            clearInterval(time)
                        }else if(document.getElementsByClassName('header_centre')[0]){
                            clearInterval(time)
                        }
                    },10)
                }else{
                    var time = setInterval(function(){
                        if(document.getElementsByClassName('header_centre')[0]){
                            document.getElementsByClassName('header_centre')[0].className = 'header box';
                            clearInterval(time)
                        }else if(document.getElementsByClassName('header')[0]){
                            clearInterval(time)
                        }
                    },10)
                }
                store.commit('routerLink',{
                    linkTo:to.path
                })
                next();
            }else{
                store._vm.$message({
                  showClose: true,
                  message:store._vm.version==0?'无查看权限':'No view permissions',
                  type: 'warning'
                });
            }
        }else{
            storage.setItem('loginState','false');
            window.location.href='login.html';
        }
    }
})

var vm=new Vue({
  store,
  router,
  el: '#newsunlamp',
  components:{app},
  template: '<app/>'
})


// WEBPACK FOOTER //
// ./src/main.js